var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F44",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8M5.529 5.53c.26-.26.682-.26.942 0l1.53 1.529 1.528-1.53a.667.667 0 0 1 .943.944L8.942 8l1.53 1.529a.667.667 0 0 1-.943.943L8 8.943l-1.529 1.529a.667.667 0 1 1-.942-.943L7.057 8 5.53 6.472a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  })));
};
export default SvgCrossCircle;